<!--
/**
  * 附件详情弹窗
  * @author weili
  * @date 2023-8-18
  */
-->
<template>
  <EXDialog title="附件详情" width="40%" :showVisible="curShowVisible" @close="close">
    <div>
        <div class="con-box">
        <div class="each" >
          <div  style="display:block">
              <div v-for="row in attachments"  :key="row.id">
                <span class="filename"  @click="downloadFile(row)">{{row.attachName}}</span>
                <span class="size">（{{row.fileSize}}kb）</span>
                <span class="filename" @click="previewFile(row)">- 预览</span>
              </div>
          </div>
        </div>
      </div>
    <br>
    <br>
    <el-row :gutter="24">
    <el-col :span="24" style="text-align:center">  <!--设置按钮对齐方式-->
            <el-button v-reClick
                v-for="(item, index) in operationHandle"
                :key="index"
                :plain="item.plain || false"
                :type="item.type || 'primary'"
                :icon="item.icon || ''"
                :size="item.size || 'medium'"
                style="margin-right:10px"
                @click="item.handle()"
                >{{ item.label }}</el-button>
      </el-col>
    </el-row>
    </div>
  </EXDialog>
</template>
<script>
import mixin from '@/mixins/mixin'
export default {
  name: 'EXAttachsDialog',
  components: {
  },
  mixins: [mixin],
  props:{
    showVisible: Boolean,
    attachments: Array,
  },
  data() {
    return {
      operationHandle: [
        {
          label: "取消",
          size: "medium",
          plain: true,
          handle: this.close
        },
      ],
    };
  },
  created (){
  },
  mounted () {
  },
  computed:{
    curShowVisible(){
        return this.showVisible
    },
  },
  methods:{
    close(){
        this.$emit('update:showVisible', false) //关闭弹窗
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';
/deep/ .el-row{
  line-height: 0.46rem;
}
.con-box {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-left: 0.2rem;
  .each {
    width: 100%;
    line-height: 0.5rem;
    .p{ //设置内容段落样式
      line-height: 0.3rem;
      display: block;
      padding-top: 0.1rem
    }
  }
}
.filename{
  @include table_font_color($table-btn-colorD);
  &:hover{
    cursor: pointer;
    @include table_btn_color($table-btn-hoverD);
  }
}
.size{
    color: #666;
}
</style>


// WEBPACK FOOTER //
// src/components/EXDialog/EXAttachsDialog.vue